import { render } from "./PencilCircularBlueIcon.vue?vue&type=template&id=5ed611c9"
import script from "./PencilCircularBlueIcon.vue?vue&type=script&lang=js"
export * from "./PencilCircularBlueIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__